import { render, staticRenderFns } from "./ovrz7.vue?vue&type=template&id=224fcc4e"
import script from "./ovrz7.vue?vue&type=script&lang=js"
export * from "./ovrz7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports